<template>
    <div class="auth_item" :class="{
        selected: selected,
        disable: disable,
        hassub:hassub,
        open: hassub && open,
        bought: bought}"
        @click.stop="click"
        :style="{ lineHeight: link ? '17px' : '48px', paddingTop: link ? '6px' : '0',letterSpacing: link ? '1px' : '0' }"
    >
        {{name}}<br>
        <span v-if="detailName" :style="{ fontSize: '12px' }">
            {{detailName}} <a :href="link" target="_blank" class="viewIntro" v-if="detailName != '标准配置'" @click.stop>&nbsp;详情</a>
        </span>
        <a v-if='link && !detailName' :href='link' target="_blank" class="viewIntro" @click.stop>查看介绍</a>
        <div class="boughtTips">已有授权</div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'auth-choose',
        props: {
            name: {
                type: String,
                default: ''
            },
            selected: {
                type: Boolean,
                default: false
            },
            disable: {
                type: Boolean,
                default: false
            },
            hassub: {
                type: Boolean,
                default: false
            },
            open: {
                type: Boolean,
                default: false
            },
            bought: {
                type: Boolean,
                default: false
            },
            link: {
                type: String,
                default: ''
            },
            detailName: {
                type: String,
                default: ''
            }
        },
        methods: {
            click () {
                if(this.disable == true) return
                this.$emit('click')
            }
        }
    }
</script>

<style scoped>
    .auth_item {
        width: auto;
        padding: 0 8px;
        height: 50px;
        display: inline-block;
        background: white;
        text-align: center;
        border: 1px solid rgb(181, 185, 188);
        font-size: 14px;
        margin-right:6px;
        border-radius: 2px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        user-select: none;
        vertical-align: middle;
    }
    .auth_item.selected {
        border: 1px solid rgb(238, 165, 52);
        box-shadow: 0 0 3px rgb(238, 165, 52);
    }
    .auth_item.selected::after{
        content: '';
        width: 16px;
        height: 16px;
        background:url(../assets/image/nsdd.png) no-repeat 5px 3px rgb(238, 165, 52);
        border-top-left-radius: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
    }
    .auth_item:hover {
        border: 1px solid rgb(238, 165, 52);
        box-shadow: none;
    }
    .auth_item.selected.disable {
        border: 1px solid rgb(255, 208, 130);
        box-shadow: none;
        background: white;
        color: rgb(156, 156, 156);
        cursor: default;

    }
    .auth_item.selected.disable::after{
        content: '';
        width: 16px;
        height: 16px;
        background:url(../assets/image/nsdd.png) no-repeat 5px 3px rgb(255, 208, 130);
        border-top-left-radius: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
    }
    .auth_item.disable {
        background: rgb(242, 242, 242);
        border: 1px solid rgb(236, 234, 234);
        color: rgb(176, 176, 176);
    }
    .auth_item.hassub{
        background: url(../assets/image/arrow.png) no-repeat 95% white;
        background-size: 12px;
        padding-right: 23px;
    }
    .auth_item.hassub.disable{
        background: url(../assets/image/arrow.png) no-repeat 95% rgb(242, 242, 242);
        background-size: 12px;
        padding-right: 23px;
    }
    .auth_item.open{
        background: url(../assets/image/arrow_over.png) no-repeat 95% white;
        background-size: 12px;
        padding-right: 23px;
    }
    .auth_item .boughtTips{
        position: absolute;
        background: rgb(243, 157, 21);
        color: white;
        font-size: 12px;
        right: 0;
        bottom: 0;
        line-height: 12px;
        padding: 2px;
        transform: scale(0.8);
        transform-origin: 100% 100%;
        display: none;
    }
    
    .auth_item.bought{
        border: 1px solid #B5B9BC;
    }
    .auth_item.bought .boughtTips {
        display: block;
    }
    .auth_item .viewIntro{
        font-size: 12px;
        text-decoration: underline;
    }
</style>>